<!-- =========================================================================================
    File Name: DashboardEcommerce.vue
    Description: Dashboard - Ecommerce
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div>
    <div class="row">
      <!-- Chart Section (Admin Only) -->
      <div v-if="isAdmin" class="col-12">
        <div class="card">
          <div class="card-body">
            <b-row>
              <b-col md="6">
                <b-form-group label="Select Month">
                  <v-select
                    v-model="selectedMonth"
                    :options="monthOptions"
                    label="name"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    placeholder="Select Month"
                    @input="onMonthYearChange"
                  />
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group label="Select Year">
                  <v-select
                    v-model="selectedYear"
                    :options="yearOptions"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    placeholder="Select Year"
                    @input="onMonthYearChange"
                  />
                </b-form-group>
              </b-col>
            </b-row>
            <!-- Loading State -->
            <div v-if="loading" class="text-center py-4">
              <b-spinner variant="primary" label="Loading..." />
            </div>
            <!-- Error State -->
            <div v-else-if="error" class="text-center py-4">
              <p class="text-danger">{{ error }}</p>
            </div>
            <!-- Charts Section -->
            <div v-else>
              <!-- Overall Chart -->
              <div
                v-if="employeeWiseData && employeeWiseData.length > 0 && overallChartSeries.length > 0"
                class="mt-3 mb-4"
              >
                <h5 class="text-center mb-3">
                  Daily Working - {{ chartData && chartData.month ? chartData.month : 'Overall' }} {{ selectedYear }} (By Employee)
                </h5>
                <vue-apex-charts
                  type="pie"
                  height="350"
                  :options="overallChartOptions"
                  :series="overallChartSeries"
                />
              </div>
              <!-- No Data State -->
              <div
                v-if="(!employeeWiseData || employeeWiseData.length === 0) && (!overallChartSeries || overallChartSeries.length === 0)"
                class="text-center py-4"
              >
                <p class="text-muted">No data available for selected month</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Existing Table Section -->
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <!-- <h4 class="header-title">Advanced Data Table</h4> -->
            <p class="text-muted font-13 mb-0"></p>
            <!-- Table -->
            <div>
              <good-table-column-search
                :moduleapi="`${this.baseApi}/daily-working`"
                title="Daily Working"
                :columns="columns"
                routerpath="/hr/adddailyworking"
                :formOptions="formOptions"
                :newPage="true"
                :edit="edit"
                :add="add"
                :viewFields="viewFields"
                :canDelete="canDelete"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GoodTableColumnSearch from "../../../components/GoodTableColumnSearch.vue";
import { BRow, BCol, BFormGroup, BSpinner } from "bootstrap-vue";
import VueApexCharts from "vue-apexcharts";
import vSelect from "vue-select";
import axios from "@/components/axios";
import moment from "moment";
const baseApi = process.env.VUE_APP_APIENDPOINT;
export default {
  components: {
    GoodTableColumnSearch,
    BRow,
    BCol,
    BFormGroup,
    BSpinner,
    VueApexCharts,
    vSelect,
  },
  data() {
    const currentDate = new Date();
    const currentMonth = currentDate.getMonth() + 1;
    const currentYear = currentDate.getFullYear();

    // Generate month options
    const monthOptions = [
      { value: 1, name: "January" },
      { value: 2, name: "February" },
      { value: 3, name: "March" },
      { value: 4, name: "April" },
      { value: 5, name: "May" },
      { value: 6, name: "June" },
      { value: 7, name: "July" },
      { value: 8, name: "August" },
      { value: 9, name: "September" },
      { value: 10, name: "October" },
      { value: 11, name: "November" },
      { value: 12, name: "December" },
    ];

    // Generate year options (current year ± 2 years)
    const yearOptions = [];
    for (let i = currentYear - 2; i <= currentYear + 2; i++) {
      yearOptions.push(i);
    }

    return {
      edit: "",
      add: "",
      canDelete: "",
      isAdmin: false,
      baseApi: process.env.VUE_APP_APIENDPOINT,
      accessToken: localStorage.getItem("accessToken"),
      selectedMonth: monthOptions.find((m) => m.value === currentMonth),
      selectedYear: currentYear,
      monthOptions: monthOptions,
      yearOptions: yearOptions,
      chartData: null,
      employeeWiseData: [],
      loading: false,
      error: null,
      overallChartSeries: [],
      viewFields: [
        {
          label: "Date",
          field: "date",
          type: "date",
          class: "col-md-4",
        },
        {
          label: "employee",
          field: "employee",
          type: "dropdown",
          responseValue: "fullname",
          class: "col-md-4",
        },
        {
          label: "remarks",
          field: "remarks",
          type: "text",
          class: "col-md-4",
        },
        {
          label: "ducuments",
          field: "details",
          tableHead: ["From", "To", "Hours", "Work", "Description"],
          tableField: [
            {
              type: "text",
              field: "from",
            },
            {
              type: "text",
              field: "to",
            },
            {
              type: "text",
              field: "hours",
            },
            {
              type: "text",
              field: "work",
            },
            {
              type: "text",
              field: "description",
            },
          ],
          type: "multiple",
          class: "col-md-12",
        },
        {
          label: "Total hours",
          field: "total_hours",
          type: "text",
          class: "col-md-4",
        },
      ],
      columns: [
        {
          label: "Date",
          field: "date",
          type: "datetime",
          filterOptions: {
            enabled: true,
            placeholder: "Search Date",
          },
        },
        {
          label: "Employee",
          field: "user_id",
          type: "dropdown",
          searchFiled: "user_id",
          url: "getEmployee",
          responseValue: "fullname",
          filterOptions: {
            enabled: true,
            placeholder: "Search",
          },
        },
        {
          label: "Total Hours",
          field: "total_hours",
          filterOptions: {
            enabled: true,
            placeholder: "Search",
          },
        },
        {
          label: "remarks",
          field: "remarks",
          filterOptions: {
            enabled: true,
            placeholder: "Search remarks",
          },
        },
        {
          label: "Enter By",
          field: "enterby",
          type: "staticdropdown",
          url: "getUsers",
          responseValue: "fullname",
          filterOptions: {
            enabled: true,
            placeholder: "Search Name",
          },
        },
        {
          label: "Enter Date",
          field: "enterdatetime",
          type: "datetime",
          time: true,
          filterOptions: {
            enabled: true,
            placeholder: "Search Date",
          },
        },
        {
          label: "Modified By",
          field: "modifiedby",
          type: "staticdropdown",
          url: "getUsers",
          responseValue: "fullname",
          filterOptions: {
            enabled: true,
            placeholder: "Search Name",
          },
        },
        {
          label: "Modified Date",
          field: "modifieddatetime",
          time: true,
          type: "datetime",
          filterOptions: {
            enabled: true,
            placeholder: "Search Date",
          },
        },
        {
          label: "Action",
          field: "action",
        },
      ],
      formOptions: {
        formTitle: `${this.$route.query.id ? "Edit Daily Working" : "Add Daily Working"}`,
        submitRouterPath: "/hr/dailyworking",
        usersDropdown: true,
        branchDropdown: true,
        designationDropdown: true,
        method: "post",
        action: "add",
        url: `${baseApi}/daily-working`,
        getEditValue: `${baseApi}/get-Daily-Working-By-Id`,
        inputFields: [],
      },
    };
  },
  computed: {
    overallChartOptions() {
      // Generate colors for all employees (use a color palette)
      const colorPalette = [
        "#4CAF50", "#FF9800", "#2196F3", "#FFC107", "#9C27B0", "#F44336",
        "#00BCD4", "#8BC34A", "#FF5722", "#3F51B5", "#E91E63", "#009688",
        "#FFC107", "#795548", "#607D8B", "#CDDC39", "#FFEB3B", "#FF9800",
        "#9E9E9E", "#00E676", "#FF1744", "#651FFF", "#1DE9B6", "#FF6E40"
      ];
      
      // Get employee names for labels
      const labels = this.employeeWiseData && this.employeeWiseData.length > 0
        ? this.employeeWiseData.map((emp) => emp.employee_name)
        : [];
      
      // Generate colors array (repeat if needed for more employees)
      const colors = labels.map((label, index) => 
        colorPalette[index % colorPalette.length]
      );
      
      return {
        chart: {
          type: "pie",
          toolbar: {
            show: false,
          },
        },
        labels: labels,
        colors: colors,
        legend: {
          position: "bottom",
          fontSize: "12px",
        },
        tooltip: {
          y: {
            formatter: (val, { seriesIndex, w }) => {
              const total = w.globals.seriesTotals.reduce((a, b) => a + b, 0);
              const percentage = total > 0 ? ((val / total) * 100).toFixed(1) : 0;
              return `${val} records (${percentage}%)`;
            },
          },
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 200,
              },
              legend: {
                position: "bottom",
                fontSize: "10px",
              },
            },
          },
        ],
      };
    },
  },
  mounted() {
    const userData = JSON.parse(localStorage.getItem("UserRights") || "[]");
    const userDataObj = JSON.parse(localStorage.getItem("userData") || "{}");
    const role = userDataObj ? userDataObj.role : "";
    
    // Check if user is admin - set this FIRST before any other logic
    this.isAdmin = role === "admin";
    
    if (role !== "admin") {
      let hasPermission = false;
      
      // Check module permissions
      if (userData && Array.isArray(userData)) {
        userData.forEach((item) => {
          if (item.modulename == "Daily Working") {
            this.edit = item.edit;
            this.add = item.add;
            this.canDelete = item.delete;
            if (item.edit === 1 || item.add === 1 || item.delete === 1 || item.view === 1) {
              hasPermission = true;
            }
          }
        });
      }
      
      // Check widget permissions if no module permission found
      if (!hasPermission) {
        const userWidgets = this.$store.state.app.user_widgets || [];
        if (userWidgets && userWidgets.length > 0) {
          const hasWidgetPermission = userWidgets.some(widget => {
            if (!widget || !widget.name) return false;
            const widgetName = (widget.name || '').toLowerCase();
            const widgetView = widget.view === true || widget.view === 1;
            return widgetView && (widgetName === 'daily working' || widgetName.includes('daily working') || 'daily working'.includes(widgetName));
          });
          
          if (hasWidgetPermission) {
            hasPermission = true;
          }
        }
      }
      
      // Check approval permissions if still no permission found
      if (!hasPermission) {
        const userApprovals = this.$store.state.app.user_approval || [];
        if (userApprovals && userApprovals.length > 0) {
          const hasApprovalPermission = userApprovals.some(approval => {
            if (!approval || !approval.module || !approval.module.name) return false;
            const moduleName = (approval.module.name || '').toLowerCase();
            return moduleName === 'daily working' || moduleName.includes('daily working') || 'daily working'.includes(moduleName);
          });
          
          if (hasApprovalPermission) {
            hasPermission = true;
          }
        }
      }
      
      // Check reminder permissions if still no permission found
      if (!hasPermission) {
        try {
          const userReminders = JSON.parse(localStorage.getItem('UserReminders') || '[]');
          if (userReminders && userReminders.length > 0) {
            const hasReminderPermission = userReminders.some(reminder => {
              if (!reminder || !reminder.name) return false;
              const reminderName = (reminder.name || '').toLowerCase();
              return reminderName === 'daily working' || reminderName.includes('daily working') || 'daily working'.includes(reminderName);
            });
            
            if (hasReminderPermission) {
              hasPermission = true;
            }
          }
        } catch (error) {
          // Ignore parsing errors
        }
      }
      
      // Only redirect if no permissions found at all
      if (!hasPermission && this.$route.path !== '/') {
        this.$router.push("/").catch(err => {
          // Ignore NavigationDuplicated errors
          if (err.name !== 'NavigationDuplicated') {
            console.error('Navigation error:', err);
          }
        });
        return;
      }
    }
    
    // Fetch chart data for current month/year (Admin only)
    // Double check isAdmin to prevent any accidental API calls
    if (this.isAdmin === true && this.selectedMonth && this.selectedYear) {
      this.fetchDailyWorkingPieChart(this.selectedMonth.value, this.selectedYear);
    }
  },
  methods: {
    async fetchDailyWorkingPieChart(month, year) {
      // Early return - prevent API call if user is not admin
      if (!this.isAdmin) {
        console.warn("Chart data fetch prevented: User is not admin");
        return;
      }
      
      this.loading = true;
      this.error = null;
      try {
        const response = await axios({
          method: "GET",
          url: `${this.baseApi}/v1/dashboard/daily-working-pie-chart`,
          params: {
            month: month,
            year: year,
          },
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.accessToken}`,
          },
        });

        if (response.data.status && response.data.data) {
          this.chartData = response.data.data;
          
          // Store employee-wise data if available (employee_wise is at root level, not inside data)
          if (response.data.employee_wise && Array.isArray(response.data.employee_wise)) {
            this.employeeWiseData = response.data.employee_wise;
          } else {
            this.employeeWiseData = [];
          }
          
          // Update overall chart series from employee_wise data (total_records)
          if (this.employeeWiseData && this.employeeWiseData.length > 0) {
            this.overallChartSeries = this.employeeWiseData.map((emp) => emp.total_records);
          } else {
            this.overallChartSeries = [];
          }
        } else {
          this.error = response.data.message || "Failed to fetch chart data";
          this.chartData = null;
          this.employeeWiseData = [];
          this.overallChartSeries = [];
        }
      } catch (error) {
        console.error("Error fetching pie chart data:", error);
        // Handle 403 Forbidden (Access denied for non-admin)
        // Silently handle 403 - don't show error or trigger any logout
        if (error.response && error.response.status === 403) {
          // Just set error state, don't throw or propagate
          this.error = null; // Don't show error for 403, just hide chart
          this.chartData = null;
          this.employeeWiseData = [];
          this.overallChartSeries = [];
          // Don't log this as it's expected for non-admin users
        } else {
          // Only show error for other types of errors
          this.error = error.response?.data?.message || "Error fetching chart data";
          this.chartData = null;
          this.employeeWiseData = [];
          this.overallChartSeries = [];
        }
      } finally {
        this.loading = false;
      }
    },
    onMonthYearChange() {
      // Only fetch if user is admin - double check to prevent any API calls
      if (this.isAdmin === true && this.selectedMonth && this.selectedYear) {
        this.fetchDailyWorkingPieChart(
          this.selectedMonth.value,
          this.selectedYear
        );
      }
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-good-table.scss";
</style>
